/**
 * converts raw papaparse output into an array of student data objects
 * @param {array} data raw output of csv rows from papaparse
 * @returns {array} an array of student data objects 
 */
export default function convertCSVToObjects (data) {
  if (!data) return null
  let output = []
  
  // keys are the fields in the first row
  let keys = data[0]

  // iterate over each row and create objects using the keys
  data.forEach((row, n) => {
    if (n === 0) return
    let obj = {}
    row.forEach((col, m) => {
      obj[keys[m]] = col
    })
    obj.row = n + 1
    output.push(obj)
  })

  // Removes last element of output if it's a null (papaparse
  // sometimes leaves a trailing empty row)
  if (output.slice(-1).length < 3) {
    output.pop()
  }
  console.log('convertCSVToObjects', output)
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/convertCSVToObjects.js